import Marquee from "react-fast-marquee";

const WORDS = [
  "Tide Water Studios Inc.",
  "Strategic Oversight",
  "Technical Consulting",
  "Adaptive Software",
  "Northern Enterprise",
];

const Star = () => (
  <span className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-[#8CA3B8] align-middle" />
);

export const BrandMarquee = () => {
  return (
    <div
      className="relative border-y border-[#0C2340]/10 bg-[#DCE4EE] py-8"
      data-testid="brand-marquee"
    >
      <Marquee speed={30} gradient gradientColor="#DCE4EE" gradientWidth={160}>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl text-[#1E3A5F] md:text-5xl">
              {w}
            </span>
            <Star />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
